import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import useI18nContext from "../../hooks/general/useI18nContext";
import PrimaryAndSecondaryTypography from "../PrimaryAndSecondaryTypography";
import { BsPeopleFill, BsLightningChargeFill } from "react-icons/bs";
import { useHistory } from "react-router";
import { useState } from "react";
import { runYearlyResetScript } from "../../lib/helpers/scripts";
import { useMutation } from "react-query";
import { useCurrentUser } from "../../contexts/AuthContext";
import getUserPermissions from "../../lib/helpers/getUserPermissions";

export default function Admin() {
  const userQuery = useCurrentUser();
  const { t } = useI18nContext();
  const { push } = useHistory();
  const [resetting, setResetting] = useState(false);
  const [resettingConfirmation, setResettingConfirmation] = useState("");
  const toggleResetting = () => setResetting((old) => !old);

  // Checking whether the user a super admin that can reset the DB
  const canUserResetDB = getUserPermissions(userQuery.data) >= 4;

  const resetDBMutation = useMutation({
    mutationFn: runYearlyResetScript,
  });

  return (
    <>
      <PrimaryAndSecondaryTypography
        primaryProps={{ variant: "h2", gutterBottom: true }}
        primary={t?.adminPage}
      />
      <Box
        display="flex"
        flexDirection="column"
        height="512px"
        justifyContent={"space-between"}
      >
        <List>
          <ListItemButton divider onClick={() => push("/admin/users")}>
            <ListItemIcon>
              <BsPeopleFill />
            </ListItemIcon>
            <ListItemText primary={t?.manageUsers} />
          </ListItemButton>
          <ListItemButton divider onClick={() => push("/admin/activities")}>
            <ListItemIcon>
              <BsLightningChargeFill />
            </ListItemIcon>
            <ListItemText primary={t?.manageActivities} />
          </ListItemButton>
        </List>
        {canUserResetDB && (
          <Card>
            <CardContent>
              <Typography fontWeight="bold">{t?.resetDBTitle}</Typography>
              <Typography>{t?.resetDBDescription}</Typography>
            </CardContent>
            <Box display="flex" justifyContent={"flex-end"} p={2}>
              <Button
                variant="contained"
                color="error"
                onClick={() => toggleResetting()}
              >
                {t?.resetDB}
              </Button>
            </Box>
          </Card>
        )}
      </Box>
      <Dialog dir="rtl" open={resetting} onClose={() => toggleResetting()}>
        <DialogTitle>{t?.resetDB}</DialogTitle>
        <DialogContent>{t.resetDBConfirmation}</DialogContent>
        <Box px={2} width="100%">
          <TextField
            sx={{ width: "100%" }}
            placeholder={t.resetDBPlaceholder}
            value={resettingConfirmation}
            onChange={(e) => setResettingConfirmation(e.target.value)}
          />
        </Box>
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button
            disabled={
              t.resetDBPlaceholder !== resettingConfirmation ||
              resetDBMutation.isLoading
            }
            variant="contained"
            color="error"
            onClick={async () => {
              await resetDBMutation.mutateAsync();

              alert(t.success);
              alert(t.manuallyResetDB)
              toggleResetting();
            }}
          >
            {resetDBMutation.isLoading ? t.loadingDoNotClose : t?.resetDB}
          </Button>
        </Box>
      </Dialog>
    </>
  );
}
